<template>
  <SignInPage :sign-in-function="signIn" :source="'admin'" />
</template>

<script setup lang="ts">
import SignInPage from '~/../member-webapp-shared/components/auth/SignInPage.vue'

definePageMeta({
  auth: { unauthenticatedOnly: true, navigateAuthenticatedTo: '/' },
})

const { signIn } = useAuth()
</script>
